module.exports = __webpack_public_path__ + "img/62.8.TSS.2cf90945.png";